import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import AgencySelect from '../../../common/forms/select/AgencySelect';
import { isRequired } from '../../../../utils/validators';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';

const IncidentsSearchForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Agencia" required>
        <Field
          name="agency"
          component={AgencySelect}
          onlyUserAgencies
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Fecha" required>
        <Field
          name="dateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonColor="secondary"
      saveButtonDisabled={loading}
    />
  </Form>
);

IncidentsSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

IncidentsSearchForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: 'IncidentsSearchForm',
})(IncidentsSearchForm);
